import React, { createContext, useContext, useState } from 'react'

interface FiltersProdutos {
  status: string
  distId: number
  distName: string
}

interface FilterProdutosType {
  filters: FiltersProdutos
  setFilters: React.Dispatch<React.SetStateAction<FiltersProdutos>>
}

const FilterContextProdutos = createContext<FilterProdutosType | undefined>(undefined)

export const FilterProviderProduto: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<FiltersProdutos>({
    status: '',
    distId: 0,
    distName: '',
  })

  return (
    <FilterContextProdutos.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContextProdutos.Provider>
  )
}

export const useFilterProdutos = (): FilterProdutosType => {
  const context = useContext(FilterContextProdutos)
  if (!context) {
    throw new Error('useFilter must be used within a FilterProviderClient')
  }
  return context
}
